import { VpIcon, VpSticker } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

type CategoryItemProps = {
  label: string
  selected: boolean
  onClick?: () => void
  isPriority: boolean
}

export const FamilyItem = ({ label, selected, onClick, isPriority }: CategoryItemProps) => {
  const { t } = useTranslation('common')
  const selectedIcon = selected ? (
    <VpIcon
      data-testid="family-item-select-icon"
      size={24}
      name={'check'}
      color="var(--primary-blue)"
    />
  ) : (
    <></>
  )

  const prioritySticker = isPriority ? (
    <VpSticker variant="neutral" size="small" className="h-5 font-normal">
      {t('global.priority')}
    </VpSticker>
  ) : (
    <></>
  )
  const labelClass = isPriority ? 'w-9/12' : 'w-11/12'
  const iconContainerClass = isPriority ? 'w-3/12' : 'w-1/12'

  return (
    <li className="w-full list-none">
      <button
        onClick={onClick}
        className={`w-full flex gap-2 py-5 justify-between text-gray-900 text-start`}
      >
        <div className={labelClass}>{label}</div>
        <div className={`${iconContainerClass} flex flex-row justify-between`}>
          <div className="text-center">{prioritySticker}</div>
          <div className="text-center">{selectedIcon}</div>
        </div>
      </button>
    </li>
  )
}
